import { LoadablePaint, LoadableAfterPaint } from '@confluence/loadable';

import { RestrictionsButtonPlaceholder } from './RestrictionsButtonPlaceholder.tsx';
import { RestrictionsButtonLoading } from './RestrictionsButtonLoading.tsx';

export const RestrictionsButtonLoaderPaint = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RestrictionsButton" */ './RestrictionsButton.tsx'))
			.RestrictionsButton,
	loading: RestrictionsButtonLoading,
});

export const RestrictionsButtonLoaderAfterPaint = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RestrictionsButton" */ './RestrictionsButton.tsx'))
			.RestrictionsButton,
	loading: RestrictionsButtonPlaceholder,
});
